export const countryCodeMap: { [key: string]: string } = {
  'AD': 'AND',
  'AE': 'ARE',
  'AF': 'AFG',
  'AG': 'ATG',
  'AI': 'AIA',
  'AL': 'ALB',
  'AM': 'ARM',
  'AN': 'ANT',
  'AO': 'AGO',
  'AR': 'ARG',
  'AS': 'ASM',
  'AT': 'AUT',
  'AU': 'AUS',
  'AW': 'ABW',
  'AZ': 'AZE',
  'BA': 'BIH',
  'BB': 'BRB',
  'BD': 'BGD',
  'BE': 'BEL',
  'BF': 'BFA',
  'BG': 'BGR',
  'BH': 'BHR',
  'BI': 'BDI',
  'BJ': 'BEN',
  'BM': 'BMU',
  'BN': 'BRN',
  'BO': 'BOL',
  'BR': 'BRA',
  'BS': 'BHS',
  'BT': 'BTN',
  'BW': 'BWA',
  'BY': 'BLR',
  'BZ': 'BLZ',
  'CA': 'CAN',
  'CF': 'CAF',
  'CG': 'COG',
  'CH': 'CHE',
  'CI': 'CIV',
  'CL': 'CHL',
  'CM': 'CMR',
  'CN': 'CHN',
  'CO': 'COL',
  'CR': 'CRI',
  'CU': 'CUB',
  'CV': 'CPV',
  'CY': 'CYP',
  'CZ': 'CZE',
  'DE': 'DEU',
  'DJ': 'DJI',
  'DK': 'DNK',
  'DM': 'DMA',
  'DO': 'DOM',
  'DZ': 'DZA',
  'EC': 'ECU',
  'EE': 'EST',
  'EG': 'EGY',
  'ER': 'ERI',
  'ES': 'ESP',
  'ET': 'ETH',
  'EU': '',
  'FI': 'FIN',
  'FJ': 'FJI',
  'FM': 'FSM',
  'FO': 'FRO',
  'FR': 'FRA',
  'GA': 'GAB',
  'GB': 'GBR',
  'GD': 'GRD',
  'GE': 'GEO',
  'GF': 'GUF',
  'GH': 'GHA',
  'GL': 'GRL',
  'GM': 'GMB',
  'GP': 'GLP',
  'GQ': 'GNQ',
  'GR': 'GRC',
  'GT': 'GTM',
  'GU': 'GUM',
  'GW': 'GNB',
  'HK': ' HKG',
  'HN': 'HND',
  'HR': 'HRV',
  'HT': 'HTI',
  'HU': 'HUN',
  'ID': 'IDN',
  'IE': 'IRL',
  'IL': 'ISR',
  'IN': 'IND',
  'IQ': 'IRQ',
  'IR': 'IRN',
  'IS': 'ISL',
  'IT': 'ITA',
  'JO': 'JOR',
  'JP': 'JPN',
  'KE': 'KEN',
  'KG': 'KGZ',
  'KH': 'KHM',
  'KI': 'KIR',
  'KM': 'COM',
  'KN': 'KNA',
  'KP': 'PRK',
  'KR': 'KOR',
  'KW': 'KWT',
  'KZ': 'KAZ',
  'LA': 'LAO',
  'LB': 'LBN',
  'LC': 'LCA',
  'LI': 'LIE',
  'LK': 'LKA',
  'LR': 'LBR',
  'LS': 'LSO',
  'LT': 'LTU',
  'LU': 'LUX',
  'LV': 'LVA',
  'LY': 'LBY',
  'MA': 'MAR',
  'MC': 'MCO',
  'MD': 'MDA',
  'ME': 'MNE',
  'MG': 'MDG',
  'MH': 'MHL',
  'ML': 'MLI',
  'MM': 'MMR',
  'MN': 'MNG',
  'MO': 'MAC',
  'MP': 'MNP',
  'MQ': 'MTQ',
  'MR': 'MRT',
  'MS': 'MSR',
  'MT': 'MLT',
  'MU': 'MUS',
  'MV': 'MDV',
  'MW': 'MWI',
  'MX': 'MEX',
  'MY': 'MYS',
  'MZ': 'MOZ',
  'NA': 'NAM',
  'NC': 'NCL',
  'NE': 'NER',
  'NG': 'NGA',
  'NI': 'NIC',
  'NL': 'NLD',
  'NO': 'NOR',
  'NP': 'NPL',
  'NR': 'NRU',
  'NZ': 'NZL',
  'OM': 'OMN',
  'PA': 'PAN',
  'PE': 'PER',
  'PF': 'PYF',
  'PG': 'PNG',
  'PH': 'PHL',
  'PK': 'PAK',
  'PL': 'POL',
  'PN': 'PCN',
  'PR': 'PRI',
  'PS': 'PSE',
  'PT': 'PRT',
  'PW': 'PLW',
  'PY': 'PRY',
  'QA': 'QAT',
  'RE': 'REU',
  'RO': 'ROU',
  'RS': 'SRB',
  'RU': 'RUS',
  'RW': 'RWA',
  'SA': 'SAU',
  'SB': 'SLB',
  'SC': 'SYC',
  'SD': 'SDN',
  'SE': 'SWE',
  'SG': 'SGP',
  'SI': 'SVN',
  'SK': 'SVK',
  'SL': 'SLE',
  'SM': 'SMR',
  'SN': 'SEN',
  'SO': 'SOM',
  'SR': 'SUR',
  'ST': 'STP',
  'SV': 'SLV',
  'SY': 'SYR',
  'SZ': 'SWZ',
  'TD': 'TCD',
  'TG': 'TGO',
  'TH': 'THA',
  'TJ': 'TJK',
  'TL': 'TLS',
  'TM': 'TKM',
  'TN': 'TUN',
  'TO': 'TON',
  'TR': 'TUR',
  'TT': 'TTO',
  'TV': 'TUV',
  'TW': 'TWN',
  'TZ': 'TZA',
  'UA': 'UKR',
  'UG': 'UGA',
  'US': 'USA',
  'UY': 'URY',
  'UZ': 'UZB',
  'VC': 'VCT',
  'VE': 'VEN',
  'VG': 'VGB',
  'VI': 'VIR',
  'VN': 'VNM',
  'VU': 'VUT',
  'WS': 'WSM',
  'YE': 'YEM',
  'ZA': 'ZAF',
  'ZM': 'ZMB',
  'ZW': 'ZWE',
}
